<!--
 @description 自动巡检配置
 @author xiehan
 @date 2020/03/11
-->
<template>
    <div class="autoInspectionConfig__content">
      <el-form ref="searchForm" :model="searchForm" :inline="true" input-width="auto">
        <el-form-item :label="$t('logComponentManage.site')">
          <g-select :list="siteList" v-model="searchForm.siteCode"></g-select>
        </el-form-item>
        <el-form-item :label="$t('autoInspectionConfig.system')">
          <g-select :list="select_system" v-model="searchForm.system" @change="getResource()" :defaultAll="true"></g-select>
        </el-form-item>
        <el-form-item :label="$t('autoInspectionConfig.resourceType')">
          <g-select :list="select_resource" v-model="searchForm.resourceType" @change="getItem()" :defaultAll="true"></g-select>
        </el-form-item>
        <el-form-item :label="$t('autoInspectionConfig.item')">
          <g-select :list="select_item" v-model="searchForm.item" :defaultAll="true"></g-select>
        </el-form-item>
        <el-form-item input-width="auto">
          <el-button type="primary" 
            @click="search"
            v-g-rac="gRac('autoInspectionConfig@search')"
            v-text="$t('common.search')"></el-button>
          <el-button type="primary" 
            @click="addConfig"
            v-g-rac="gRac('autoInspectionConfig@add')"
            v-text="$t('common.add')"></el-button>
        </el-form-item>
      </el-form>
      <el-table-extend
        :data="tData" 
        :head="tHead" 
        :currentChange="tCurrentChange" 
        :sizeChange="tSizeChange"
        border>
        <template slot="control-column" slot-scope="{data}">
          <el-table-extend-control 
            :control="tableControl" 
            :data="data" 
            :label="$t('common.handle')">
          </el-table-extend-control>
        </template>
      </el-table-extend>
      <el-dialog :closeOnClickModal="false"
        :title="configDiaTitle"
        :visible.sync="configDiaVis"
        width="680px">
        <el-form :inline="true" ref="handleForm" :model="handleForm" input-width="180px" label-width="80px" :rules="rules">
          <el-form-item :label="$t('autoInspectionConfig.siteCode')" prop="siteCode">
            <g-select v-model="handleForm.siteCode" :list="siteList"></g-select>
          </el-form-item>
          <el-form-item :label="$t('autoInspectionConfig.system')" prop="system">
            <g-select v-model="handleForm.system" :list="select_system" @change="getHandleResource()"></g-select>
          </el-form-item>
          <el-form-item :label="$t('autoInspectionConfig.resourceType')" prop="resourceType">
            <g-select v-model="handleForm.resourceType" :list="select_handleResource" @change="getHandleItem()"></g-select>
          </el-form-item>
          <el-form-item :label="$t('autoInspectionConfig.item')" prop="item">
            <g-select v-model="handleForm.item" :list="select_handleItem"></g-select>
          </el-form-item>
          <el-form-item :label="$t('autoInspectionConfig.host')" prop="host" input-width="auto">
            <el-button type="primary" @click="showHostList = !showHostList" v-text="hostListBtnText"></el-button>
            <el-collapse-transition>
              <div v-show="showHostList">
                <el-transfer 
                ref="transferForm"
                v-model="handleForm.host" 
                :data="hostList" 
                filterable 
                :filter-method="filterHost"
                :titles="hostTitle"></el-transfer>
              </div>
            </el-collapse-transition>
          </el-form-item>
          <el-form-item :label="$t('autoInspectionConfig.rule')" input-width="380px">
            <table style="margin-top: 10px;">
              <thead>
                <tr>
                  <th class="t-border" v-text="$t('autoInspectionConfig.ruleMethod')"></th>
                  <th class="t-border" v-text="$t('autoInspectionConfig.ruleValue')"></th>
                  <el-button type="primary" @click="handleForm.rule.push({
                    key: '',
                    val: ''
                  })" v-text="$t('common.add')" style="margin-left: 4px"></el-button>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in handleForm.rule" :key="index">
                  <td class="t-border">
                    <g-select v-model="item.key" :list="select_rule"></g-select>
                  </td>
                  <td class="t-border">
                    <el-input v-model.number="item.val" type="number"></el-input>
                  </td>
                  <el-button type="primary"
                    @click="handleForm.rule.splice(index, 1)"
                    style="margin-left: 4px"
                    v-text="$t('common.delete')"></el-button>
                </tr>
              </tbody>
            </table>
          </el-form-item>
          <el-form-item :label="$t('autoInspectionConfig.enabled')">
            <el-radio-group v-model="handleForm.enabled">
              <el-radio label="1">{{ $t('dataDictionary.yes') }}</el-radio>
              <el-radio label="0">{{ $t('dataDictionary.no') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="configDiaVis = false" v-text="$t('common.cancel')"></el-button>
          <el-button type="primary" @click="configDiaConfirm" v-text="$t('common.submit')"></el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
    import autoInsepctionBiz from '@/logic/systemDiagram/autoInspectionBiz.js'
    import SiteListBiz from '@/logic/cmdb/cmdbBiz'
    import dic from '@/components/mixins/dic'
    import cmdbBiz from '@/logic/cmdb/cmdbBiz'
    import table from '@/components/mixins/table'
    import { extend } from '@/utils/tool'
    import rac from '@/plugins/rac-mixin.js'
    const DIC_MAP = {
      item: 'itemmoduletype',
      system: 'systemmoduletype',
      resourceType: 'resourcemoduletype'
    }
    export default {
      mixins: [dic, table, rac],
      data () {
        return {
          siteList: {},
          doExport: null,
          select_system: {},
          select_allResource: {},
          select_allItem: {},
          select_resource: {},
          select_item: {},
          select_handleResource: {},
          select_handleItem: {},
          select_enabled: {
            true: this.$t('dataDictionary.yes'),
            false: this.$t('dataDictionary.no')
          },
          rules: {},
          configDiaVis: false,
          showHostList: false,
          hostListBtnText: this.$t('platform.open'),
          hostList: [],
          filterHost (query, item) {
            return String(item['key']).indexOf(query) > -1
          },
          hostTitle: [],
          selectId: '',
          configDiaTitle: '',
          tableControl: [
            {
              label: this.$t('common.edit'),
              callback: (row, index, data) => {
                this.configDiaVis = true
                this.configDiaTitle = this.$t('common.edit')
                this.selectId = row.id
                for (let i in this.handleForm) {
                  this.handleForm[i] = row[i] === undefined ? '' : row[i]
                }
                this.setEditForm()
              },
              rac: () => this.gRac('autoInspectionConfig@edit')
            }, {
              label: this.$t('common.delete'),
              callback: (row, index, data) => {
                this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
                  confirmButtonText: this.$t('common.confirm'),
                  cancelButtonText: this.$t('common.cancel'),
                  type: 'warning'
                }).then(() => {
                  autoInsepctionBiz.deleteConfig({ id: row.id, siteCode: this.searchForm.siteCode }).then(() => {
                    this.successMessage()
                    this.searchTable()
                  })
                }).catch(() => {})
              },
              rac: () => this.gRac('autoInspectionConfig@delete')
            }
          ],
          searchForm: {
            siteCode: '',
            system: '',
            resourceType: '',
            item: ''
          },
          handleForm: {
            siteCode: '',
            system: '',
            resourceType: '',
            host: [],
            item: '',
            rule: [],
            enabled: '1',
          }
        }
      },
      methods: {
        async preInitTable () {
          await Promise.all([
            this.getResource(true),
            this.getItem(true),
            this.dGetDictionaryByCode('systemmoduletype'),
            this.dGetDictionaryByCode('rulemoduletype')
          ])
          this.select_system = { ...this.dDictionary.systemmoduletype }
          this.select_rule = { ...this.dDictionary.rulemoduletype }
          this.initTable()
          this.setRules()
          this.getHostList()
        },
        initTable () {
          this.tInitTable({
            lanKey: 'autoInspectionConfig.table',
            head: ['siteCode', 'system', 'resourceType', 'item', 'enabled'],
            requestFun: this.searchTable,
            headOpt: {
              item: {
                formatter: 'Dictionary',
                formatterDic: this.select_item
              },
              system: {
                formatter: 'Dictionary',
                formatterDic: this.select_system
              },
              resourceType: {
                formatter: 'Dictionary',
                formatterDic: this.select_resource
              },
              siteCode: {
                formatter: 'Dictionary',
                formatterDic: this.siteList
              },
              enabled: {
                formatter: 'Dictionary',
                formatterDic: this.select_enabled
              }
            }
          })
        },
        getHostList () {
          cmdbBiz.hostList({ perPageCount: 99999 }).then((data) => {
            if (data && data.dataList && data.dataList.length > 0) {
              let arr = []
              data.dataList.map(item => {
                let obj = { key: item.ip1, label: item.ip1 }
                arr.push(obj)
              })
              this.hostList = arr
            }
          })
        },
        search () {
          this.tResetPage()
          this.searchTable()
        },
        searchTable () {
          const reqData = extend(true, { ...this.tPageInfo }, this.searchForm)
          if (!reqData.system) reqData.system = 0
          if (!reqData.resourceType) reqData.resourceType = ''
          if (!reqData.item) reqData.item = 0
          // Object.keys(reqData).map(item => {
          //   if (reqData[item] === '') delete reqData[item]
          // })
          autoInsepctionBiz.getConfig(reqData).then((data) => {
            this.tData = data
          })
        },
        getSiteList () {
          SiteListBiz.siteList({perPageCount: 500}).then((data) => {
            let list = {}
            data.dataList.map((item) => {
              list[item.siteCode] = item.name
            })
            this.siteList = list
            this.searchForm.siteCode = Object.keys(this.siteList)[0]
            this.preInitTable()
            this.searchTable()
          })
        },
        getResource (init = false) {
          return autoInsepctionBiz.getResource({ system: this.searchForm.system || 0}).then((data) => {
            let obj = {}
            if (data) data.map(item => obj[item] = item)
            this.select_resource = obj
            this.searchForm.resourceType = ''
            if (init) this.select_allResource = obj
            if (!init) this.getItem()
          })
        },
        getHandleResource (isEdit = false) {
          return autoInsepctionBiz.getResource({ system: this.handleForm.system || 0}).then((data) => {
            let obj = {}
            if (data) data.map(item => obj[item] = item)
            this.select_handleResource = obj
            if (isEdit) {
              this.handleForm.resourceType = Object.keys(this.select_resource)
                .filter(item => this.select_allResource[item] === this.handleForm.resourceType)[0]
            } else {
              this.handleForm.resourceType = Object.keys(this.select_handleResource)[0] || ''
            }
            this.getHandleItem(isEdit)
          })
        },
        getItem (init = false) {
          return autoInsepctionBiz.getItem({ system: this.searchForm.system || 0,
              resourceType: this.searchForm.resourceType || '' }).then((data) => {
            this.select_item = data || {}
            this.searchForm.item = ''
            if (init) this.select_allItem = data || {}
          })
        },
        getHandleItem (isEdit = false) {
          return autoInsepctionBiz.getItem({ system: this.handleForm.system || 0,
              resourceType: this.handleForm.resourceType || '' }).then((data) => {
            this.select_handleItem = data || {}
            if (isEdit) {
              this.handleForm.item = Object.keys(this.select_item)
                .filter(item => this.select_allItem[item] === this.handleForm.item)[0]
            } else {
              this.handleForm.item = Object.keys(this.select_handleItem)[0] || ''
            }
          })
        },
        setEditForm () {
          this.handleForm.siteCode = Object.keys(this.siteList)
            .filter(item => this.siteList[item] === this.handleForm.siteCode)[0]
          this.handleForm.system = Object.keys(this.select_system)
            .filter(item => this.select_system[item] === this.handleForm.system)[0]
          this.handleForm.enabled = this.handleForm.enabled === this.$t('dataDictionary.yes') ? '1' : '0'
          if (this.handleForm.rule && Object.keys(this.handleForm.rule).length > 0) {
            let ruleList = []
            Object.keys(this.handleForm.rule).map(item => {
              ruleList.push({
                key: item,
                val: this.handleForm.rule[item]
              })
            })
            this.handleForm.rule = ruleList
          } else {
            this.handleForm.rule = []
          }
          this.$nextTick(() => {
            this.$refs.transferForm.clearQuery('left')
            this.$refs.transferForm.clearQuery('right')
          })
          this.getHandleResource(true)
        },
        successMessage () {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
        },
        setRules () {
          this.rules = {
            siteCode: { required: true, message: `${this.$t('common.entryTips')}${this.$t('autoInspectionConfig.siteCode')}` },
            system: { required: true, message: `${this.$t('common.entryTips')}${this.$t('autoInspectionConfig.system')}` },
            resourceType: { required: true, message: `${this.$t('common.entryTips')}${this.$t('autoInspectionConfig.resourceType')}` },
            item: { required: true, message: `${this.$t('common.entryTips')}${this.$t('autoInspectionConfig.item')}` }
          }
        },
        addConfig () {
          this.configDiaTitle = this.$t('common.add')
          this.configDiaVis = true
          for (let i in this.handleForm) {
            this.handleForm[i] = ''
          }
          this.handleForm.system = Object.keys(this.select_system)[0]
          this.getHandleResource()
          this.handleForm.host = []
          this.handleForm.rule = []
          this.handleForm.enabled = '1'
          this.$nextTick(() => {
            this.$refs['handleForm'].clearValidate()
            this.$refs.transferForm.clearQuery('left')
            this.$refs.transferForm.clearQuery('right')
          })
        },
        configDiaConfirm () {
          this.$refs['handleForm'].validate((valid) => {
            if (valid) {
              let eventName = this.configDiaTitle === this.$t('common.edit')
                ? 'updateConfig' : 'saveConfig'
              let saveObj = { ...this.handleForm }
              let itemObj = {}
              saveObj.rule.map(item => {
                itemObj[item.key] = item.val
              })
              saveObj.rule = itemObj
              saveObj.enabled = saveObj.enabled === '1'
              if (this.configDiaTitle === this.$t('common.edit')) saveObj.id = this.selectId
              autoInsepctionBiz[eventName](saveObj).then(data => {
                this.configDiaVis = false
                this.successMessage()
                this.searchTable()
              })
            } else {
              return false
            }
          })
        }
      },
      watch: {
        showHostList (val) {
          this.hostTitle = [this.$t('platform.hostList'), this.$t('platform.choosen')]
          this.hostListBtnText = val ? this.$t('platform.hide') : this.$t('platform.open')
        },
        configDiaVis (val) {
          if (!val) this.showHostList = false
        }
      },
      mounted () {
        this.getSiteList()
      }
    }
  </script>
  
  <style>
    .autoInspectionConfig__content table {
      border-collapse: collapse;
      border-spacing: 0;
    }
    .autoInspectionConfig__content .t-border {
      height: 30px;
      width: 150px;
      padding: 0 4px;
      border: 1px solid #ddd;
      text-align: left;
      font-weight: normal;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .autoInspectionConfig__content .t-border .el-input--medium .el-input__inner {
      border: none;
    }
  </style>